import {useEffect, useState} from "react";

const allowedEnvs = ["local", "dev", "prod"];


const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (consent === "true") {
      loadAnalytics();
    }
    setShowBanner(!consent);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "true");
    setShowBanner(false);
    loadAnalytics();
  };

  const rejectCookies = () => {
    localStorage.setItem("cookie_consent", "false");
    setShowBanner(false);
    console.log("User rejected cookies");
  };

  // Handle privacy policy link click
  const handlePrivacyClick = (e) => {
    e.preventDefault();

    // Use History API to navigate to /privacy without reloading the page
    window.history.pushState({}, "", "/privacy");

    // Dispatch a popstate event to trigger React Router's detection
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const loadAnalytics = () => {
    const env = import.meta.env.VITE_ENV;
    const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

    if (env && allowedEnvs.includes(env) && measurementId) {
      const gtagScript = document.createElement("script");
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;

      const gaScript = document.createElement("script");
      gaScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${measurementId}');
      `;

      document.head.appendChild(gtagScript);
      document.head.appendChild(gaScript);

      console.log(`Google Analytics loaded with ID: ${measurementId} in ${env} environment`);
    }
  };

  if (!showBanner) return null;

  return (
      <div className="fixed bottom-0 left-0 right-0 bg-[#0F172A] text-white py-4 px-6 z-50">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-sm px-4">
          <div className="text-center md:text-left">
            We use cookies to improve your experience. By using our site, you agree to our{" "}
            <a
                href="/privacy"
                onClick={handlePrivacyClick}
                className="underline text-blue-300 hover:text-blue-400 transition-colors ml-1"
            >
              Privacy Policy
            </a>.
          </div>
          <div className="flex items-center gap-2">
            <button
                onClick={acceptCookies}
                className="mt-3 md:mt-0 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg text-sm transition-colors"
            >
              Accept
            </button>
            <button
                onClick={rejectCookies}
                className="mt-3 md:mt-0 bg-white text-[#0F172A] font-semibold py-2 px-6 rounded-lg text-sm border border-[#0F172A] transition-colors hover:bg-gray-100"
            >
              Reject
            </button>
          </div>
        </div>
      </div>
  );
};

export default CookieBanner;